import React, { memo, useRef, useEffect, useState } from "react";

import { getClass } from "src/utils";
import { useStore } from "src/store";
import { Icon } from "src/primitives";
import Storage from "src/storage";
import { useSticky } from "src/content/utils";

import styles from "./style.css";

const PromptGDPR = memo(() => {
  const store = useStore("config");
  const { gdpr } = store("config");
  const {
    style,
    maxNotifications = 2,
    message = "By continuing to use this website you agree to the terms outlined in the Privacy Policy and Cookie Policy"
  } = gdpr || {};

  const isBottom = style === "bottom";

  const [shown, setShown] = useState(true);
  const [currentNotifications] = useState(Storage.get("gdpr-notification-count"));

  const ref = useRef();

  useSticky(ref, !isBottom);
  useEffect(() => {
    Storage.set("gdpr-notification-count", currentNotifications + 1);
  }, []);

  return gdpr && currentNotifications < maxNotifications && shown ? (
    <div ref={ref} class={getClass(styles.container, isBottom && styles.bottom)}>
      <div dangerouslySetInnerHTML={{ __html: message }}></div>
      <Icon size={0.7} name="close" onClick={() => setShown(false)} />
    </div>
  ) : null;
});

export default PromptGDPR;
